<template>
  <a-modal
    title="扣除返利"
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :maskClosable="false"
  >
    <a-form :form="form">
      <a-form-item label="消息">
        <robot-dialoague-input v-decorator="['content']" :nouns="nouns | StrToArr"></robot-dialoague-input>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSeccess">完成</a-button>
    </template>
  </a-modal>
</template>

<script>
import FansApi from '@/api/fans'
import { mapActions } from 'vuex'
import RobotDialoagueInput from '@/views/components/RobotDialoagueInput'

export default {
  components: {
    RobotDialoagueInput,
  },

  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      selectdData: [],
      nouns: '订单号,商品名称,违规原因,会员名称,会员wxid,订单创建时间,换行',
      userInfo: {},
      balance: 0, // 余额
      trjid: '', // 上级
      ssjTrjid: '', // 上上级
    }
  },

  filters: {
    StrToArr(str) {
      return !str || str == '' || str == null || str == ' ' ? [] : str.split(',')
    },
  },

  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),

    show(list) {
      this.selectdData = list.map(item => {
        return {
          fl_agent: item.tb_order_info.fl_agent, // 上级获得的返利
          fl_second: item.tb_order_info.fl_second, // 上上级获得的返利
          balance: item.tb_order_info.fl_user, // 用户获得的返利
          uid: item.tb_order_info.user_info.uid, // 用于获取用户画像
          sub_id: item.sub_info.sub_id,
          tb_trade_id: item.tb_trade_id, // 订单号
          item_title: item.tb_order_info.item_title, // 商品名称
          violation_type: item.violation_type, // 违规原因
          nickname: item.tb_order_info.user_info.nickname, // 会员名称
          wxid: item.tb_order_info.wxid, // 会员wxid
          tk_trade_create_time: item.tk_trade_create_time, //订单创建时间
        }
      })
      this.visible = true
    },

    handleCancel() {
      this.visible = false
      this.nouns = null
    },

    handleSeccess() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let wxid = 'wxid_1t5f433yc4kn22'
          let subId = 31974
          let len = this.selectdData.length
          let resultMsg = '' // 发送的微信消息
          // console.log('this.selectdData=', this.selectdData)
          for (let i = 0; i < len; i++) {
            // resultMsg = values.content
            //   .replace(/\[换行\]/g, '\n')
            //   .replace('[订单号]', this.selectdData[i].tb_trade_id)
            //   .replace('[商品名称]', this.selectdData[i].item_title)
            //   .replace('[违规原因]', this.selectdData[i].violation_type)
            //   .replace('[会员名称]', this.selectdData[i].nickname)
            //   .replace('[会员wxid]', this.selectdData[i].wxid)
            //   .replace('[订单创建时间]', this.selectdData[i].tk_trade_create_time)
            // console.log('resultMsg=', resultMsg)
            // setTimeout(() => {
            //   // 给用户发送消息
            //   const msgData = {
            //     user: [wxid],
            //     // user: [this.selectdData[i].wxid],
            //     msg_type: '1',
            //     msg_content: resultMsg,
            //   }
            //   this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            //     robotid: subId,
            //     // robotid: this.selectdData[i].sub_id,
            //     type: 'sendmsg',
            //     data: msgData,
            //   }).then(result => {
            //     this.visible = false
            //   })
            // }, i * 3000)

            // 扣除返利，逐级扣除：先扣用户、再扣上级、再扣上上级
            this.selectdData[i].sub_id = 31974
            this.selectdData[i].uid = 29
            console.log('this.selectdData=', this.selectdData)
            // 调取用户画像的接口
            let tempData = await this.getUserInfo(this.selectdData[i].sub_id, this.selectdData[i].uid)
            this.userInfo = tempData.data
            this.balance = parseFloat(this.userInfo.balance) - parseFloat(this.selectdData[i].balance) // 用户画像的余额 - 此违规订单的余额
            console.log(`用户余额=${parseFloat(this.userInfo.balance)} - ${parseFloat(this.selectdData[i].balance)}`)
            this.trjid = this.userInfo.trjid ? this.userInfo.trjid : '' // 这个字段就是(上级的uid)
            // 调用修改余额的接口
            this.editBalance(
              this.selectdData[i].uid,this.selectdData[i].sub_id,this.trjid,this.balance,this.userInfo.integral,this.userInfo.usertype,this.userInfo.order_sixbit
            ).catch(error => {
              console.log('扣除用户余额失败', error)
            })

            // 如果上级存在，扣除上级的余额
            if (this.trjid) {
              // 调取用户画像的接口
              let tempDataSj = await this.getUserInfo(this.selectdData[i].sub_id, this.trjid)
              this.userInfo = tempDataSj.data
              this.balance = parseFloat(this.userInfo.balance) - parseFloat(this.selectdData[i].fl_agent) // 用户画像的余额 - 此违规订单的余额
              console.log(`上级余额=${parseFloat(this.userInfo.balance)} - ${parseFloat(this.selectdData[i].fl_agent)}`)
              this.ssjTrjid = this.userInfo.trjid ? this.userInfo.trjid : '' // 这个字段就是(上上级的uid)
              // 调用修改余额的接口
              this.editBalance(
                this.trjid,this.selectdData[i].sub_id,this.userInfo.trjid,this.balance,this.userInfo.integral,this.userInfo.usertype,this.userInfo.order_sixbit
              ).catch(error => {
                console.log('扣除上级余额失败', error)
              })

              // 如果上上级存在，扣除上上级的余额
              if (this.ssjTrjid) {
                // 调取用户画像的接口
                let tempDataSsj = await this.getUserInfo(this.selectdData[i].sub_id, this.ssjTrjid)
                this.userInfo = tempDataSsj.data
                this.balance = parseFloat(this.userInfo.balance) - parseFloat(this.selectdData[i].fl_second) // 用户画像的余额 - 此违规订单的余额
                console.log(`上上级余额=${parseFloat(this.userInfo.balance)} - ${parseFloat(this.selectdData[i].fl_second)}`)
                this.trjid = this.userInfo.trjid ? this.userInfo.trjid : '' // 这个字段就是(上级的uid)
                // 调用修改余额的接口
                this.editBalance(
                  this.ssjTrjid,this.selectdData[i].sub_id,this.userInfo.trjid,this.balance,this.userInfo.integral,this.userInfo.usertype,this.userInfo.order_sixbit
                ).catch(error => {
                  console.log('扣除上上级余额失败', error)
                })
              }
            }

          }
        }
      })
    },

    // 获取用户画像
    getUserInfo(sub_id, uid) {
      return FansApi.getFansInfo({
        sub_id,
        uid,
      })
    },

    // 修改余额
    editBalance(uid, sub_id, trjid, balance, integral, usertype, order_sixbit) {
      FansApi.updateFensInfo({
        uid,
        sub_id,
        trjid,
        balance,
        integral,
        usertype,
        order_sixbit,
      })
    },
  },
}
</script>

<style lang="less"></style>
